import { InfoMessage } from '@fasstech/middle-design-system';
import { isNil } from 'ramda';

export const RedirectionCcnInfo = ({ comment }) => {
  if (isNil(comment)) console.error('We need a comment to display');
  return (<div>
    <InfoMessage iconName='lightbulb'>
      <p>{comment}</p>
    </InfoMessage>
  </div>);
};
